/* global System */

export default {
  Hero: () => System.import(/* webpackChunkName: "Hero" */ './index'),
}
